<template>
	<div>
		<template v-if="isLoaded">
			<div class="container has-text-centered">
				<h1 class="title is-1">
					{{ $t('piterkit') }}
				</h1>
				<h3 class="subtitle is-4 mb-5">
					{{ stage_title }}
				</h3>

				<h4 class="subtitle is-4 mb-5">
					{{ movie_session_title }}
				</h4>

				<template v-if="registration_success">
					<div class="has-text-success">
						{{ $t('registered_successfully') }}
						<br>
						{{ $t('view_link_is_sent') }}
						<br>
						<strong class="has-text-primary">{{ email }}</strong>.

						<p style="font-size: 0.9em;" class="mb-3 mt-3" v-html="$t('email_instructions')" />

						<p>
							<button type="button" class="button is-normal mt-2 mb-4" @click="registration_success = false">
								{{ $t('register_one_more_time') }}
							</button>
						</p>

						<a href="#" style="color: #fff; border-bottom: 1px dashed #fff;" @click="modalOpen = true">
							{{ $t('still_got_no_mail') }}
						</a>

						<div class="modal" id="contact_support_instructions" :class="[{ 'is-active': modalOpen }]">
							<div class="modal-background"></div>
							<div class="modal-content">
								<div class="box">
									{{ $t('contact_support_instructions_1') }}
									<a :href="'mailto:pokazrabotpiterkit@gmail.com?subject='+$t('cannot_get_my_link')">
										pokazrabotpiterkit@gmail.com
									</a>
									{{ $t('contact_support_instructions_2') }}
								</div>
								<button class="button is-primary is-outlined" @click="modalOpen = false">
									{{ $t('i_got_it') }}
								</button>
							</div>
						</div>
					</div>
				</template>
				<template v-else>
					<template v-if="registration_open">

						<template v-if="has_free_e_tickets">
							<div class="reg-desc">
								<p class="mb-2">
									{{ $t('register.need_email') }}
								</p>
								<p class="mb-2">
									{{ $t('register.will_send') }}
								</p>
								<p class="mb-2">
									{{ $t('register.follow_link') }}
								</p>
							</div>

							<h3 class="title is-4 mb-3 mt-4">
								{{ $t('register.enter_email') }}
							</h3>

							<div class="field" style="max-width: 300px; margin: 0 auto;">
								<div class="control is-large">
									<input 
										class="input is-normal" 
										:class="[{ 'is-danger': !isEmailValid() && email, 'is-success': isEmailValid() }]" 
										type="email" 
										v-model="email" 
										@keyup.enter="enterInput"
										placeholder="" />
								</div>
							</div>
						</template>
						<div class="has-text-danger" style="font-size: 1.4em;" v-else>
							{{ $t('there_are_no_tickets_left') }}
							<br>
							<router-link class="button is-outlined is-light mt-3" :to="'/stage/'+stage_id+'/foyer'">
								{{ $t('to_sessions_list') }}
							</router-link>
						</div>

					</template>
					<div style="font-size: 1.4em;" v-else>
						<div class="has-text-danger mb-4">
							{{ $t('session_registration_has_ended') }}
						</div>

						<router-link class="button is-outlined is-light" :to="'/stage/'+stage_id+'/foyer'">
							{{ $t('to_sessions_list') }}
						</router-link>
					</div>
				</template>
			</div>

			<footer class="p-2" v-if="!registration_success">
				<div class="box footer-box">
					<div class="has-text-left">
						<template v-if="!is_running && !is_ended && !is_stopped">
							<template v-if="past_due">
								<strong>
									{{ $t('session_will_start_soon') }}
								</strong>
							</template>
							<template v-else>
								{{ $t('will_start_in') }}
								<span style="font-size: 16px; white-space: nowrap;" :class="[{ 'has-text-danger': expiring }]">
									{{ countdown }}
								</span>
							</template>
						</template>
						<template v-else>
							<strong>
								{{ $t('session_is_running') }}
							</strong>
						</template>
					</div>
					<div v-if="has_free_e_tickets">
						<button 
							class="button is-success is-rounded is-normal" 
							:class="[{ 'is-loading': isRegistering }]" 
							:disabled="!isEmailValid()" 
							@click="sendRegistration"
						>
							<span>
								{{ $t('action.go') }}
							</span>
						</button>
					</div>
				</div>
			</footer>

		</template>

		<div class="modal alert-modal" :class="[{ 'is-active': alertModalOpen }]">
			<div class="modal-background"></div>
			<div class="modal-content">

				<article class="message is-dark">
					<div class="message-header">
						<p>
							{{ $t('alert_header') }}
						</p>
						<button class="delete" aria-label="delete" @click="alertModalOpen = false"></button>
					</div>
					<div class="message-body">
						<template v-if="alert_message">
							{{ $t(alert_message) }}
						</template>
					</div>
				</article>
			</div>
		</div>

	</div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
	name: 'SessionFoyer',
	props: {
		movie_session_id: {
			required: true
		}
	},
	data(){
		return {
			registration_open: false,
			registration_success: false,
			movie_session_title: null,
			stage_title: null,
			stage_id: null,
			movie_session_start: null,
			movie_session_started_at: null,
			movie_session_viewing_ended_at: null,
			movie_session_stopped_at: null,
			movie_session_closed_at: null,
			has_free_e_tickets: true,
			isLoaded: false,
			isRegistering: false,
			countdown: null,
			email: null,
			expiring: false,
			TMID: null,
			modalOpen: false,
			alertModalOpen: false,
			alert_message: null,
			// eslint-disable-next-line
			reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
		}
	},
	mounted(){
		this.getMovieSession()

		window.Echo.channel('movie-session-change-state').listen('MovieSessionChangeState', data => {
			if(data.payload.movie_session && this.movie_session_id == data.payload.movie_session.id){
				if(data.payload.action == 'close_registration'){
					
						this.registration_open = false
						//alert('Регистрация на этот показа завершилась')
						clearInterval(this.TMID)
						//this.$router.push('/')
					
				} else if(data.payload.action == 'open_registration'){
					this.registration_open = true
					//location.reload()
				}
			}
		})
	},
	computed: {
		not_started(){
			return !this.movie_session_started_at
		},
		is_running(){
			return this.movie_session_started_at && !this.movie_session_viewing_ended_at && !this.movie_session_stopped_at
		},
		is_ended(){
			return this.movie_session_started_at && this.movie_session_viewing_ended_at
		},
		is_stopped(){
			return this.movie_session_started_at && this.movie_session_stopped_at
		},
		is_opened(){
			return this.movie_session_opened_at && !this.movie_session_closed_at
		},
		is_closed(){
			return this.movie_session_opened_at && this.movie_session_closed_at
		},
		past_due(){
			return !this.timeLeft()
		}
	},
	methods: {
		enterInput(){
			if(this.isEmailValid()){
				this.sendRegistration()
			}
		},
		isEmailValid(){
			return (this.email == "") ? "" : (this.reg.test(this.email)) ? true : false
		},
		async getMovieSession(){
			await axios.get(`${process.env.VUE_APP_API_LOCATION}/api/movie_sessions/${this.movie_session_id}/foyer`).then(r => {

				if(r.data.result == 'error'){
					this.alert_message = r.data.message
					this.alertModalOpen = true

					setTimeout(() => {
						this.$router.replace('/')
					}, 4000)
					
				} else {

					this.movie_session_title = r.data.data.movie_session_title
					this.movie_session_start = r.data.data.start
					this.movie_session_started_at = r.data.data.movie_session_started_at
					this.movie_session_viewing_ended_at = r.data.data.movie_session_viewing_ended_at
					this.movie_session_stopped_at = r.data.data.movie_session_stopped_at
					this.movie_session_closed_at = r.data.data.movie_session_closed_at
					this.has_free_e_tickets = r.data.data.has_free_e_tickets
					this.stage_title = r.data.data.stage_title
					this.stage_id = r.data.data.stage_id
					this.isLoaded = true
					this.registration_open = true

					if(this.timeLeft()){
						this.startTimer()
					}
				}
			})
		},
		timeLeft(){
			var duration = moment.duration(moment(this.movie_session_start).diff(moment()));
			var seconds = duration.asSeconds();

			if(seconds < 0){
				return false
			}

			let format = 'HH:mm:ss'

			if(parseInt(seconds) > 86400){
				format = 'DD ['+this.$t('days')+'] HH:mm:ss'
			}
			this.countdown = moment.utc(seconds*1000).format(format)

			if(seconds == 120){
				this.expiring - true
			}

			return seconds
		},
		startTimer(){
			this.TMID = setInterval(() => {
				this.timeLeft()
			}, 1000)
		},
		async sendRegistration(){
			if(!this.has_free_e_tickets){
				this.alert_message = 'sorry_out_of_tickets'
				this.alertModalOpen = true

				setTimeout(() => {
					this.$router.replace(`/stage/${this.stage_id}/foyer`)
				}, 4000)

				return false
			}

			await axios.post(`${process.env.VUE_APP_API_LOCATION}/api/movie_sessions/${this.movie_session_id}/register`, { email: this.email, locale: this.$i18n.locale }).then(r => {
				if(r.data.result == 'ok'){
					this.registration_success = true
				} else {
					this.alert_message = r.data.message
					this.alertModalOpen = true
					console.log(this.alert_message)
				}
			})
		}
	}
}
</script>

<style>
footer{
	position: fixed;
	bottom: 0px;
	left: 0;
	width: 100%;
}
.footer-box{
	max-width: 960px; 
	margin: 0 auto; 
	box-shadow: 0 0 10px rgba(0,0,0,0.5); 
	display: flex; 
	justify-content: space-between; 
	align-items: center;
}
.reg-desc p{
	font-size: 0.9em;
}
</style>